<template>
  <a-layout id="components-layout-demo-custom-trigger">
    <a-layout-sider :trigger="null" collapsible>
      <a-menu
        theme="dark"
        mode="inline"
        :default-selected-keys="iShow"
        :open-keys="openKeys"
        @openChange="handleOpenChange"
      >
        <a-menu-item key="5" @click="SwitchClick('home')">
          <a-icon type="home" />
          <span>首页</span>
        </a-menu-item>
        <a-menu-item key="1" @click="SwitchClick('customer')">
          <a-icon type="usergroup-add" />
          <span>客户管理</span>
        </a-menu-item>
        <a-menu-item key="2" @click="SwitchClick('order')">
          <a-icon type="profile" />
          <span>运单管理</span>
        </a-menu-item>
        <a-sub-menu key="sub-crm" id="sub-menu">
          <template #title>
            <span>
              <a-icon type="solution" />
              <span>CRM管理</span>
            </span>
          </template>
          <a-menu-item key="8" @click="SwitchClick('crmDetail')">
            CRM详情
          </a-menu-item>
          <a-menu-item key="9" @click="SwitchClick('crmSum')">
            CRM统计
          </a-menu-item>
        </a-sub-menu>
        <a-sub-menu
          key="sub-caidan"
          id="sub-menu"
          v-show="roleId != 6 && roleId != 1 && roleId != 8 && roleId != 10"
        >
          <template #title>
            <span>
              <a-icon type="container" />
              <span>财务管理</span>
            </span>
          </template>
          <a-menu-item
            v-show="roleId != 6 && roleId != 7 && roleId != 8 && roleId != 10"
            key="3"
            @click="SwitchClick('profit')"
          >
            利润报表
          </a-menu-item>
          <a-menu-item
            v-show="roleId != 6 && roleId != 8 && roleId != 10"
            key="6"
            @click="SwitchClick('royalty')"
          >
            提成明细
          </a-menu-item>
          <a-menu-item
            v-show="roleId != 6 && roleId != 7 && roleId != 8 && roleId != 10"
            key="7"
            @click="SwitchClick('cost')"
          >
            公司成本表
          </a-menu-item>
        </a-sub-menu>
        <a-sub-menu
          key="sub-system"
          id="sub-menu"
          v-show="roleId == 2 || roleId == 3 || roleId == 4"
        >
          <template #title>
            <span>
              <a-icon type="setting" />
              <span>系统设置</span>
            </span>
          </template>
          <a-menu-item key="4" @click="SwitchClick('user')">
            用户管理
          </a-menu-item>
        </a-sub-menu>
      </a-menu>
    </a-layout-sider>
    <a-layout>
      <a-layout-content
        :style="{
          margin: '4px 24px 24px 24px',
          background: 'unset',
          minHeight: '280px',
          borderRadius: '10px',
        }"
      >
        <slot></slot>
      </a-layout-content>
    </a-layout>
  </a-layout>
</template>

<script>
import Cookies from "js-cookie";

export default {
  props: {
    iShow: { type: Array },
    openKeys: { type: Array },
  },
  data() {
    return {
      roleId: 2,
      selectedKeys: [], // 控制选中的菜单项
      lastOpenKey: null, // 记录最新点击的子菜单 key
    };
  },
  methods: {
    SwitchClick(path) {
      this.$router.push({ path });
      this.updateMenuState(path); // 确保在点击后更新菜单状态
    },
    handleOpenChange(openKeys) {
      let keys = this.openKeys || [];
      const latestOpenKey = openKeys.find((key) => keys.indexOf(key) === -1);

      if (latestOpenKey) {
        // 展开新的子菜单
        this.openKeys = [latestOpenKey];
        this.lastOpenKey = latestOpenKey;
        if (latestOpenKey == "sub-caidan") {
          this.$router.push({
            path: this.roleId == 7 ? "royalty" : "profit",
          });
        } else if (latestOpenKey == "sub-crm") {
          this.$router.push({
            path: "crmDetail",
          });
        } else {
          this.$router.push({ path: "user" });
        }
      } else {
        // 收缩子菜单
        this.openKeys = [];
        this.lastOpenKey = null;
      }
    },
    updateMenuState(path) {
      // 根据路由路径更新菜单状态
      if (
        path.includes("profit") ||
        path.includes("royalty") ||
        path.includes("cost")
      ) {
        this.openKeys = ["sub-caidan"];
      } else if (path.includes("user")) {
        this.openKeys = ["sub-system"];
      } else if (path.includes("crm")) {
        this.openKeys = ["sub-crm"];
      } else {
        this.openKeys = [];
      }
    },
  },
  mounted() {
    this.roleId = Cookies.get("roleId"); //客户1，管理员2，财务3，经理4，5运作主管，运作6，电销主管7，电销8，业务主管9，业务10
    this.updateMenuState(this.$route.path);
  },
  created() {
    this.roleId = Cookies.get("roleId"); //客户1，管理员2，财务3，经理4，5运作主管，运作6，电销主管7，电销8，业务主管9，业务10
  },
};
</script>
<style lang="less" scoped>
#components-layout-demo-custom-trigger {
  width: 100% !important;
  height: 100% !important;
  .ant-layout {
    background: unset !important;
  }
  /deep/.ant-layout-sider,
  .ant-menu-dark {
    background: unset !important;
  }
  /deep/.ant-layout-sider-children,
  .ant-menu-dark {
    font-family: PingFangSC, PingFang SC;
    font-weight: 500;
    font-size: 16px;
    color: #313332;
    line-height: 22px;
    text-align: left;
    font-style: normal;
  }
  /deep/.ant-menu-dark .ant-menu-item {
    font-family: PingFangSC, PingFang SC;
    font-weight: 500;
    font-size: 16px;
    color: #313332 !important;
    font-style: normal;
  }
  /deep/.ant-menu-dark .ant-menu-submenu-title:hover {
    color: unset !important;
  }
  /deep/.ant-menu-dark .ant-menu-submenu-active {
    color: unset !important;
  }
  /deep/.ant-menu-dark .ant-menu-submenu-selected {
    color: #fff !important;
  }
  /deep/.ant-menu-dark .ant-menu-submenu-title .ant-menu-submenu-arrow::before {
    background: #313332 !important;
  }
  /deep/.ant-menu-dark .ant-menu-submenu-title .ant-menu-submenu-arrow::after {
    background: #313332 !important;
  }
  #sub-menu {
    /deep/.ant-menu-item-selected {
      font-family: PingFangSC, PingFang SC;
      font-weight: 600;
      font-size: 16px;
      background: transparent !important;
      color: #14cc76 !important;
      font-style: normal;
    }
  }
  /deep/.ant-menu-item-selected {
    background: linear-gradient(90deg, #14cc76 0%, #e6cf5c 100%);
    border-radius: 0px 8px 8px 0px;
  }
  /deep/.ant-menu-dark .ant-menu-submenu-open {
    background: linear-gradient(90deg, #14cc76 0%, #e6cf5c 100%);
    border-radius: 0px 8px 8px 0px;
  }
  /deep/.ant-menu-dark .ant-menu-inline.ant-menu-sub {
    background: #e3f3ea;
    box-shadow: unset;
  }
  /deep/.ant-menu-submenu-title {
    font-size: 16px;
  }
  #components-layout-demo-custom-trigger .trigger {
    font-size: 18px;
    line-height: 64px;
    padding: 0 24px;
    cursor: pointer;
    transition: color 0.3s;
  }
  #components-layout-demo-custom-trigger .trigger:hover {
    color: #749bf4;
  }

  #components-layout-demo-custom-trigger .logo {
    height: 32px;
    background: rgba(255, 255, 255, 0.2);
    margin: 16px;
  }
}
</style>
